// extracted by mini-css-extract-plugin
export default {"author-card":"AuthorCard_author-card__2FiPa","title":"AuthorCard_title__UXCHR","link":"AuthorCard_link__HytgV"};